import { Injectable, Inject } from '@angular/core';
import { Http, Response, Headers } from '@angular/http';
import { BlogCategory } from '../../models/blog/blog-category-model';
import { Blog } from '../../models/blog/blog-model';
import { Observable } from 'rxjs/Observable';
import { Router } from "@angular/router";
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import { CookieService } from 'ngx-cookie-service';
@Injectable()
export class BlogCategoryService {
  constructor(private http: Http, private readonly router: Router, private cookieService: CookieService) { }
  private serviceName = 'api/Blog';
  getBlogCategory() {
    return this.http.get(`${this.serviceName}`, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }
  getBlogActiveCategory() {
    return this.http.get(`${this.serviceName}/GetBlogActiveCategory`, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  addBlogCategory(model: BlogCategory) {
    return this.http.post(`${this.serviceName}/CreateBlogCategory`, model, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  updateBlogCategory(model: BlogCategory) {
    return this.http.post(`${this.serviceName}/UpdateBlogCategory`, model, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }
  updateBlog(model: Blog) {
    return this.http.post(`${this.serviceName}/UpdateBlog`, model, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  } 
  deleteBlogCategory(id: string) {
    return this.http.get(`${this.serviceName}/DeleteBlogCategory?id=` + id, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }
  deleteBlog(id: string) {
    return this.http.get(`${this.serviceName}/DeleteBlog?id=` + id, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }
  getBlogCategoryById(blogCategoryId: string) {
    return this.http.get(`${this.serviceName}/GetBlogCategoryById?id=` + blogCategoryId, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }
  getBlogById(blogId: string) {
    return this.http.get(`${this.serviceName}/GetBlogById?id=` + blogId, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }
  GetBlogStatus() {
    return this.http.get(`${this.serviceName}/GetBlogStatus`, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }
  AddBlog(model: Blog) {
    return this.http
      .post(`${this.serviceName}`, model, {
        headers: new Headers({
          "Token": this.cookieService.get('Login')
        })
      })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }
  AddBlogLogo(formData: any, userId: number): void {
    this.http
      .post(`${this.serviceName}/SaveBlogLogo?userId=` + userId, formData, {
        headers: new Headers({
          "Token": this.cookieService.get('Login')
        })
      })
      .subscribe(result => {
        setTimeout(() => {
          this.router.navigate(["/blog-list"]);
        }, 1000);

      });
  }
  isUniqueUrl(url: string, id: number) {
    return this.http
      .get(`${this.serviceName}/IsUniqueUrl?url=` + url + '&Id=' + id, {
        headers: new Headers({
          "Token": this.cookieService.get('Login')
        })
      })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }
  GetBlogs() {
    return this.http.get(`${this.serviceName}/GetBlogs`, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }
  errorHandler(error: Response) {
    
    return Observable.throw(error);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/blog/blog-category.service.ts